import http from "../../services/http";
import { __api_getDealerEquipmentList} from "./admin.endpoints";
import { __api_moveDealerEquipmentList} from "./admin.endpoints";

export const getDealersList = () => http.Request("GET", __api_getDealerEquipmentList);

export const getDealerEquipmentList = (companyName) => http.Request("GET", __api_getDealerEquipmentList+"?serviceProvider="+companyName);

export const moveEquipmentList = (data) => http.Request("POST", __api_moveDealerEquipmentList,data);